import { useEffect } from "react";
import {
  COMMON_PATHS,
  findLayersOrLayerAssets,
  getPath,
} from "@blings/blings-player";

type InteractiveLayerChange = {
  assetId?: string;
  layerName: string;
  layerUid?: number;
  additionals?: Array<{
    assetId?: string;
    layerName: string;
    layerUid?: number;
  }>;
  ctaName?: string;
};

export const useInteractiveCtaNameAutofill = ({
  change,
  json,
  index,
  onChange,
}: {
  change: InteractiveLayerChange;
  json?: any;
  index: number;
  onChange: (index: number, key: any, value: any) => void;
}) => {
  useEffect(() => {
    // `== null`, not falsy: an empty string is an intentional "cleared" value
    // (the input has allowClear), so the layer-text fallback must not restore
    // it. Only a never-set ctaName autofills. See 461d1c19.
    if (change.ctaName != null) return;

    const layers = findLayersOrLayerAssets({
      assetId: change.assetId,
      layerName: change.layerName,
      layerUid: change.layerUid,
      jsonVid: json,
      additionals: change.additionals,
    });
    const textLayer =
      layers?.length &&
      layers.find((layer) => getPath(layer, COMMON_PATHS.TEXT_IN_LAYER));
    if (!textLayer) return;

    const text = getPath(textLayer, COMMON_PATHS.TEXT_IN_LAYER);
    if (text) onChange(index, "ctaName", text);
  }, [
    change.ctaName,
    change.assetId,
    change.layerName,
    change.layerUid,
    change.additionals,
    json,
    onChange,
    index,
  ]);
};
